import Vue from 'vue'
import store from '@/store'

let getProduto = (tipo, configuracao) => {
    switch (tipo) {
        case 'SOLO':
            return configuracao.produto_solo;
        case 'SEMENTE':
            return configuracao.produto_semente;
        case 'TECIDO':
            return configuracao.produto_tecido;
        case 'FERTILIZANTE':
            return configuracao.produto_fertilizante;
        case 'EXTERNA':
            return configuracao.produto_externo;
        default:
            return null;
    }
}

let _enviar = async (analises, digitandoResultado = false, valoresAdicionais = null) => {

    for (const analise of analises) {
        if (analise.remetente != null && analise.remetente.endereco != null && analise.registro != undefined) {
            await Promise.all(
                analise.proprietarios.map(async (proprietario) => {
                    let editou = false;
                    if (proprietario.endereco == null) {
                        editou = true;
                        proprietario.endereco = analise.remetente.endereco;
                    }
                    if (proprietario.endereco_nro == null) {
                        editou = true;
                        proprietario.endereco_nro = analise.remetente.endereco_nro;
                    }
                    if (proprietario.cep == null) {
                        editou = true;
                        proprietario.cep = analise.remetente.cep;
                    }
                    if (proprietario.bairro == null) {
                        editou = true;
                        proprietario.bairro = analise.remetente.bairro;
                    }

                    if (editou) {
                        await Vue.http.post('api/atualizaPessoa', proprietario);
                    }
                })
            );
        }
    }

    let configuracao = store.state.Empresa.configuracao
    let dadosAnalise = DadosAnalise(analises, configuracao)
    let valorAnalise = parseFloat(dadosAnalise['valorTotal']);
    let aplicarCD = valoresAdicionais != null && (valoresAdicionais.credito > 0 || valoresAdicionais.debito > 0);

    if (aplicarCD) {
        valorAnalise = parseFloat((dadosAnalise['valorTotal'] + valoresAdicionais.debito) - valoresAdicionais.credito);
    }

    let data = {
        "itens_cadastrados": dadosAnalise['itens'],
        "pedido": {
            "pessoa_id": dadosAnalise['idPessoa'],
            "formas_pagamento_aceitas": null,
            "local_entrega": "",
            "observacoes": "",
            "baixa_estoque": "0",
            "faturado": "1",
            "vlr_bruto": valorAnalise,
            "vlr_desconto": "0.00",
            "vlr_liquido": valorAnalise,
        },
        "infNFe": {
            "serie": configuracao.serie_nfse_id,
            "natOp": null,
            "indPag": 2,
            "finNFe": 1,
        },
        "cidade_prestacao_servico": "1",
        "iss": {
            "iss_retido": "2",
            "ResponsavelRetencao": "1",
            "RazaoSocial": null,
            "CpfCnpj": null,
            "InscricaoMunicipal": null,
        },
        "tipo_documento": dadosAnalise['tipoDocumento'],
        "valor_pago": valorAnalise,
        "valor_restante": '0.00',
        "formas_pagamento": []
    }

    if (dadosAnalise['formaPagamento'] == 'BOLETO') {
        data["formas_pagamento"] = [{
            "model": {
                "tipo": "BOLETO"
            },
            "forma_pagamento_id": configuracao.forma_pagamento_boleto_id,
            "valor_recebido_cliente": valorAnalise,
            "valor_pago": valorAnalise,
            "valor_troco": "0",
            "primeira_cobranca": dadosAnalise['dataVencimento'],
            "qtd_parcelas": "1",
            "qtd_dias": "7",
            "conta_bancaria_id": configuracao.conta_bancaria_id,
            "array_parcela": [{
                "nro_parcela": "1",
                "data_vencimento": dadosAnalise['dataVencimento'],
                "valor": valorAnalise
            }],
            "taxa_adicional": "0.00",
            "taxa_juros": "0.00",
            "multa_atraso": "0.00"
        }]
    } else {
        data["formas_pagamento"] = [{
            "model": {
                "tipo": "VISTA"
            },
            "forma_pagamento_id": configuracao.forma_pagamento_vista_id,
            "valor_recebido_cliente": valorAnalise,
            "valor_pago": valorAnalise,
            "valor_total_parcelas": null,
            "valor_troco": "0"
        }]
    }


    if (aplicarCD) {
        let vlrDebito = valoresAdicionais.debito
        let vlrCredito = valoresAdicionais.credito

        data['itens_cadastrados'].forEach((item, index) => {
            let porcentagemItem = (item['vlr_total'] * 100) / dadosAnalise['valorTotal'];
            let valor = 0

            if (vlrDebito > 0) {
                if (index+1 == data['itens_cadastrados'].length) {
                    data['itens_cadastrados'][index]['vlr_total'] += vlrDebito;
                    data['itens_cadastrados'][index]['vlr_unitario'] += parseFloat((vlrDebito / item['quantidade']).toFixed(2))
                } else {
                    valor = parseFloat(((porcentagemItem * valoresAdicionais.debito) / 100).toFixed(2))
                    data['itens_cadastrados'][index]['vlr_total'] += valor;
                    data['itens_cadastrados'][index]['vlr_unitario'] += parseFloat((valor / item['quantidade']).toFixed(2))
                    vlrDebito -= valor
                }
            }

            if (vlrCredito > 0) {
                if (index+1 == data['itens_cadastrados'].length) {
                    data['itens_cadastrados'][index]['vlr_total'] -= vlrCredito;
                    data['itens_cadastrados'][index]['vlr_unitario'] -= parseFloat((vlrCredito / item['quantidade']).toFixed(2))
                } else {
                    valor = parseFloat(((porcentagemItem * valoresAdicionais.credito) / 100).toFixed(2))
                    data['itens_cadastrados'][index]['vlr_total'] -= valor;
                    data['itens_cadastrados'][index]['vlr_unitario'] -= parseFloat((valor / item['quantidade']).toFixed(2))
                    vlrCredito -= valor
                }
            }


            let complementoNome = item['complemento_apelido_produto'].substr(0, item['complemento_apelido_produto'].indexOf('Qtd '))
            data['itens_cadastrados'][index]['complemento_apelido_produto'] = complementoNome + 'Qtd ' + item['quantidade'].formatMoney(2, ',', '.') + ' Total ' + item['vlr_total'].formatMoney(2, ',', '.')
        })
    }

    return Vue.httpNumerama.post('api/pedidos/gravar', data).then(async (res) => {
        if (res.data != undefined && res.data.erro != undefined && res.data.erro === 1) {
            window.swal("Atenção", "Houve um problema ao armazenar o pedido. <br><br>" + res.data.mensagem, "warning")
            if (!digitandoResultado) {
                controlaAnalises(analises, res.data.pedido.id, false, aplicarCD)
            }
            throw new Error("Houve um problema ao armazenar o pedido. \r\n" + res.data.mensagem)
        }
        controlaAnalises(analises, res.data.pedido.id, true, aplicarCD)
        return res
    });
};

let controlaAnalises = (analises, pedidoID, atualiza = true, aplicouCreditoDebito = false) => {
    analises.forEach((analise) => {
        if (analise.id != undefined) {
            if (atualiza) {
                if(analise.subsidio_sebrae != '1') {
                    Vue.http.put('api/analises/' + analise.id, {
                        atualizarDependencia: false,
                        aplicouCreditoDebito: aplicouCreditoDebito,
                        gravaLog: false,
                        analise: {
                            "boleto": analise.boleto,
                            "pedido_id": pedidoID,
                            'emitir_nota': analise.emitir_nota,
                            'forma_pagamento': analise.forma_pagamento
                        },
                        externa: analise.tipo == undefined && analise.pix_id == null ? true : false
                    });
                }
            } else {
                Vue.http.delete("api/analises/" + analise.id)
            }
        }
    })
}

let DadosAnalise = (analises, configuracao) => {
    let produto = null
    let dadosAnalise = {
        'valorTotal': 0,
        'idPessoa': 0,
        'dataVencimento': 0,
        'tipoDocumento': 'PEDIDO',
        'formaPagamento': 'FATURADA',
        'itens': {
            'TECIDO': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
            'FERTILIZANTE': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
            'SOLO': {
                'QUIMICA': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
                'FISICA': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0 },
                'EXTRATO': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
                'API': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0}
            },
            'SEMENTE': {
                'GERMINACAO': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
                'VIGOR': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
            },
            'EXTERNA': {
                'EXTERNA': {'vlr_total': 0, 'quantidade': 0, 'vlr_unitario': 0},
            }
        }
    }

    analises.forEach((analise, index) => {
        if(parseInt(analise.subsidio_sebrae) == 0) {
            dadosAnalise['valorTotal'] += parseFloat(analise.valor_amostra)
        }
        dadosAnalise['dataVencimento'] = analise.data_vencimento != null ? analise.data_vencimento : null
        dadosAnalise['idPessoa'] = analise.pessoa_id != null ? analise.pessoa_id : (analise.remetente_id != null && analise.tipo == undefined && analise.pix_id == null ? analise.remetente_id : null)
        dadosAnalise['tipoDocumento'] = analise.emitir_nota ? "NFSE" : "PEDIDO"
        dadosAnalise['formaPagamento'] = analise.forma_pagamento
        produto = getProduto(analise.tipo, configuracao)

        if (analise.tipo == 'TECIDO' || analise.tipo == 'FERTILIZANTE') {
            dadosAnalise['itens'][analise.tipo]['vlr_total'] += (analise.tipo == 'FERTILIZANTE' ? parseFloat(analise.valor_fertilizante) : parseFloat(analise.valor_tecido))
            dadosAnalise['itens'][analise.tipo]['quantidade'] += 1
            dadosAnalise['itens'][analise.tipo]['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['vlr_total'] / dadosAnalise['itens'][analise.tipo]['quantidade']);
        } else {
            if(analise.tipo == undefined && analise.pix_id == null) {
                dadosAnalise['itens']['EXTERNA']['EXTERNA']['vlr_total'] += parseFloat(analise.valor_analise);
                dadosAnalise['itens']['EXTERNA']['EXTERNA']['quantidade'] += 1;
                dadosAnalise['itens']['EXTERNA']['EXTERNA']['vlr_unitario'] = parseFloat(analise.valor_analise);
                dadosAnalise['valorTotal'] += parseFloat(analise.valor_analise);
            }
            if (analise.solo_extrato_saturacao) {
                dadosAnalise['itens'][analise.tipo]['EXTRATO']['vlr_total'] += parseFloat(analise.valor_solo_extrato);
                dadosAnalise['itens'][analise.tipo]['EXTRATO']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['EXTRATO']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['EXTRATO']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['EXTRATO']['quantidade']);
            }

            if (analise.solo_fisica && parseInt(analise.subsidio_sebrae) == 0) {
                dadosAnalise['itens'][analise.tipo]['FISICA']['vlr_total'] += parseFloat(analise.valor_solo_fisica);
                dadosAnalise['itens'][analise.tipo]['FISICA']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['FISICA']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['FISICA']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['FISICA']['quantidade']);
            }

            if (analise.solo_quimica && parseInt(analise.subsidio_sebrae) == 0) {
                dadosAnalise['itens'][analise.tipo]['QUIMICA']['vlr_total'] += parseFloat(analise.valor_solo_quimica);
                dadosAnalise['itens'][analise.tipo]['QUIMICA']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['QUIMICA']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['QUIMICA']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['QUIMICA']['quantidade']);
            }

            if (analise.semente_germinacao) {
                dadosAnalise['itens'][analise.tipo]['GERMINACAO']['vlr_total'] += parseFloat(analise.valor_semente_germinacao);
                dadosAnalise['itens'][analise.tipo]['GERMINACAO']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['GERMINACAO']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['GERMINACAO']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['GERMINACAO']['quantidade']);
            }

            if (analise.semente_vigor) {
                dadosAnalise['itens'][analise.tipo]['VIGOR']['vlr_total'] += parseFloat(analise.valor_semente_vigor);
                dadosAnalise['itens'][analise.tipo]['VIGOR']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['VIGOR']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['VIGOR']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['VIGOR']['quantidade']);
            }
            if (analise.id_coleta_app != null) {
                dadosAnalise['itens'][analise.tipo]['API']['vlr_total'] += parseFloat(analise.valor_amostra);
                dadosAnalise['itens'][analise.tipo]['API']['quantidade'] += 1;
                dadosAnalise['itens'][analise.tipo]['API']['vlr_unitario'] = (dadosAnalise['itens'][analise.tipo]['API']['vlr_total'] / dadosAnalise['itens'][analise.tipo]['API']['quantidade']);
            }
        }
    })

    let produtos = []

    for (var [indexPai, itemPai] of Object.entries(dadosAnalise['itens'])) {
        produto = getProduto(indexPai, configuracao)
        if ((indexPai == 'TECIDO' || indexPai == 'FERTILIZANTE') && itemPai.vlr_total > 0) {
            itemPai['produto_id'] = produto.id
            itemPai['item_id'] = null
            itemPai['vlr_desconto_rateado'] = 0
            itemPai['vlr_desconto'] = '0.00'
            itemPai['tipo_estoque_id'] = 0
            itemPai["garantia"] = "0"
            itemPai["cod_barras"] = produto.cod_barras
            itemPai["apelido_produto"] = produto.apelido_produto
            itemPai["complemento_apelido_produto"] = ' ' + indexPai.toLowerCase() + " - Qtd " + (itemPai['quantidade']).formatMoney(2, ',', '.') + " Total " + (itemPai['vlr_total']).formatMoney(2, ',', '.')
            itemPai["produto"] = JSON.stringify(produto)
            produtos.push(itemPai)
        } else {
            for (var [index, item] of Object.entries(itemPai)) {
                if (item.vlr_total > 0) {
                    item['produto_id'] = produto.id
                    item['item_id'] = null
                    item['vlr_desconto_rateado'] = 0
                    item['vlr_desconto'] = '0.00'
                    item['tipo_estoque_id'] = 0
                    item["garantia"] = "0"
                    item["cod_barras"] = produto.cod_barras
                    item["apelido_produto"] = produto.apelido_produto
                    item["complemento_apelido_produto"] = ' ' + index.toLowerCase() + " - Qtd " + (item['quantidade']).formatMoney(2, ',', '.') + " Total " + (item['vlr_total']).formatMoney(2, ',', '.')
                    item["produto"] = JSON.stringify(produto)
                    produtos.push(item)
                }
            }
        }
    }
    dadosAnalise['itens'] = produtos
    return dadosAnalise
}

let enviar = async (analises, digitandoResultado = false, valoresAdicionais = null) => {
    return await _enviar(analises, digitandoResultado, valoresAdicionais)
};

export default {
    enviar
}
